/**
 * Provider serving as a configuration holder for the application
 */
class ApiData {
  constructor() {
    this.PRODUCT_CODE = 1
    this.COUNTRY_CODE = 'US'
    this.CURRENCY_CODE = 'USD'
    this.CLIENT_SESSION_ID = undefined
    this.APP_CODE = undefined
    this.PRESENTATION_INTERFACE = undefined
  }

  configure(settings) {
    Object.assign(this, settings)
  }
}

const apiData = new ApiData()

export { apiData as ApiData }
